module.exports = __webpack_public_path__ + "static/img/qita_chart.92a4a98e.png";